import React, { createContext, useContext } from 'react'

interface WorkflowContextType {
  customPluginActions?: any[]
}

const WorkflowContext = createContext<WorkflowContextType>({})

export const useWorkflowContext = () => {
  const context = useContext(WorkflowContext)
  if (!context) {
    throw new Error('useWorkflowContext must be used within a WorkflowProvider')
  }
  return context
}

interface WorkflowProviderProps {
  children: React.ReactNode
  customPluginActions?: any[]
}

export const WorkflowProvider: React.FC<WorkflowProviderProps> = ({ children, customPluginActions }) => {
  return <WorkflowContext.Provider value={{ customPluginActions }}>{children}</WorkflowContext.Provider>
}
